import API from "./axios";

/**
 * Bills and Slips on expense entries (office side).
 *
 * source: EXPENSE (expense payment) | STAFF_LEDGER | HUNDEKARI_LEDGER |
 * TRANSPORT_LEDGER; entryId: the row id. kind: BILL | SLIP. Every call that
 * changes something returns the entry's full list (bills first).
 */
const expenseAttachmentApi = {
  list: (source, entryId) => API.get("/expense-attachments", { params: { source, entryId } }),
  /** Photos or PDFs; several parts are allowed, up to 10 MB per request in all. */
  add: (source, entryId, kind, files) => {
    const fd = new FormData();
    Array.from(files).forEach(f => fd.append("files", f));
    // Content-Type left to the browser so it adds the multipart boundary.
    return API.post("/expense-attachments", fd, {
      params: { source, entryId, kind },
      headers: { "Content-Type": undefined },
    });
  },
  /** Link a bill already on another entry — one bill paid over several payments. */
  link: (source, entryId, attachmentId) => API.post("/expense-attachments/link", { source, entryId, attachmentId }),
  remove: (attachmentId) => API.delete(`/expense-attachments/${attachmentId}`),
  /** What the entry must carry: ["BILL", "SLIP"], ["SLIP"] or []. */
  required: (source, entryId) => API.get("/expense-attachments/required", { params: { source, entryId } }),
  /** Earlier bills in the company, newest first, each with the entry it was first used on. */
  recentBills: (q = "") => API.get("/expense-attachments/recent-bills", { params: { q } }),
};

export default expenseAttachmentApi;
